// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep lib-ff-select {
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/select/select.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":["::ng-deep lib-ff-select {\n  min-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
